module.exports = __webpack_public_path__ + "img/MLI.dec4b314.svg";